import { render, staticRenderFns } from "./newService.vue?vue&type=template&id=fd9e4af2&scoped=true"
import script from "./newService.vue?vue&type=script&lang=js"
export * from "./newService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9e4af2",
  null
  
)

export default component.exports